import { render, staticRenderFns } from "./SidebarFilters.vue?vue&type=template&id=4fe2ef74&scoped=true"
import script from "./SidebarFilters.vue?vue&type=script&lang=js"
export * from "./SidebarFilters.vue?vue&type=script&lang=js"
import style0 from "./SidebarFilters.vue?vue&type=style&index=0&id=4fe2ef74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe2ef74",
  null
  
)

export default component.exports